<template>
  <div>
    <md-toolbar class="main-header">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <md-button :href="url" class="md-icon-button logo">
            <img src="//img.creative.com/images/home/logo_creative.svg" alt="CREATIVE" class="logo-creative">
          </md-button>
        </div>
        <div class="md-toolbar-section-center  md-xsmall-hide">
          <ul class="nav navbar-nav main-nav">
            <li class="dropdown">
              <a :href="`${url}/sxfi`">{{$t('super-x-fi')}}</a>
            </li>
            <li class="dropdown product-menu">
              <a href="javascript:;" v-on:click="openProductMenu()">{{$t('products')}}</a>
            </li>
            <li class="dropdown">
              <a :href="`${url}/sale`">{{$t('sale')}}</a>
            </li>
            <li class="dropdown">
              <a :href="`${url}/help`">{{$t('help')}}</a>
            </li>
          </ul>
        </div>
        <div class="md-toolbar-section-end">
          <md-button class="md-icon-button login-btn" v-on:click="openLogin()" v-if="!customerDetail.loggedIn">
            <md-icon :md-src="`https://img.creative.com/images/home/icon-account.svg`">{{$t('sign-in')}}</md-icon>
          </md-button>
          <md-button class="md-icon-button login-btn" v-on:click="openAccount()" v-if="customerDetail.loggedIn">
            <md-icon :md-src="`https://img.creative.com/images/home/icon-account.svg`">{{$t('account')}}</md-icon>
          </md-button>
          <md-badge :md-content="customerDetail.cartItemCount" class="md-primary" v-if="customerDetail.cartItemCount>0" style="margin: 0 5px;">
            <md-button class="md-icon-button" :href="`${url}/shoppingcart`">
              <md-icon :md-src="`https://img.creative.com/images/home/icon-cart.svg`">cart</md-icon>
            </md-button>
          </md-badge>
          <md-button class="md-icon-button" :href="`${url}/shoppingcart`" v-if="customerDetail.cartItemCount<=0" style="margin: 0 5px;">
            <md-icon :md-src="`https://img.creative.com/images/home/icon-cart.svg`">cart</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="openSideMenu">
            <md-icon :md-src="`${imageServer}/new-rma/icon/menu.svg`">menu</md-icon>
          </md-button>
        </div>
      </div>
    </md-toolbar>
    <md-drawer class="md-right md-scrollbar" :md-active.sync="showSideMenu" v-scroll-lock="showSideMenu">
      <div style="position:relative">
        <div v-html="links"></div>
        <div class="cross-btn">
          <md-button class="md-icon-button" v-on:click="hideSideMenu">
            <md-icon :md-src="`${imageServer}/new-rma/icon/close.svg`" class="icon-cross"></md-icon>
          </md-button>
        </div>
      </div>
    </md-drawer>

  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import { storeUrl } from '../mixins/store'
  import Auth from '../mixins/auth'
  import { apiServer, imageServer } from '../config'

  import SideMenuHandler from './SideMenuHandler'

  export default {
    name: 'MainHeader',
    data: () => ({
      showSideMenu: false,
      links: '',
      productMenu: '',
      url: '',
      customerDetail: {},
      imageServer: imageServer
    }),
    computed: {
      ...mapState({
        stateTitle: 'pageTitle',
        isSplash: 'splashPage',
        currentTheme: 'theme',
        pageLoading: 'pageLoading',
        store: 'store',
        dropMenuVisible: 'dropMenuVisible'
      }),
      pageTitle() {
        const { stateTitle } = this
        return stateTitle && stateTitle
      },
      isHome() {
        return this.$route.path === '/'
      }
    },
    methods: {
      ...mapMutations({
        showDropMenu: types.SHOW_DROP_MENU,
        hideDropMenu: types.HIDE_DROP_MENU,
        setupDropMenu: types.CHANGE_DROP_MENU
      }),
      htmlFilter(html) {
        html = html.replace(/document.write\('\s'\);/gi, '')
        html = html.replace(/document.write\('/gi, '')
        html = html.replace(/'\);/gi, '')
        html = html.replace(/src="\/content2/gi, 'src="' + this.url + '/content2/')
        html = html.replace(/href="\//gi, 'href="' + this.url + '/')
        return html
      },
      openProductMenu() {
        this.setupDropMenu({ type: 'html', content: this.productMenu, height: 'auto' })
        if (this.dropMenuVisible) this.hideDropMenu()
        else this.showDropMenu()
      },
      openSideMenu() {
        this.hideDropMenu()
        this.showSideMenu = true
      },
      hideSideMenu() {
        this.showSideMenu = false
      },
      openLogin() {
        this.setupDropMenu({ type: 'iframe', url: `${this.url}/account/signup?layout=no&source=topmenu`, height: 'auto' })
        this.showDropMenu()
      },
      openAccount() {
        this.setupDropMenu({ type: 'account-menu', account: this.customerDetail, height: 'auto' })
        this.showDropMenu()
      },
      applyLayout2024() {
        //get store
        const country = (this.store || '').toLowerCase().trim()

        // apply layout-2024 except HK, CN, TW
        if (['hk', 'cn', 'tw'].includes(country)) return

        document.documentElement.classList.add('layout-2024')
      }
    },
    beforeMount() {
      this.applyLayout2024()
    },
    async created() {
      this.url = storeUrl(this.store)
      const r = await this.$http.request({ url: `${apiServer}/api/your-details/customer?store=` + this.store, method: 'post', headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).catch(() => { })
      if (r && r.status == 200) {
        if (r.data) this.customerDetail = r.data
      }
    },
    async mounted() {
      this.url = storeUrl(this.store)
      if (this.url && this.url.length > 0) {
        const m = await this.$http
          .request({
            url: `https://api.creative.com/page/api/v2/pages/template/${this.store}`,
            method: 'get'
          })
          .catch(() => null);

        const data = m?.data;
        if (!data) return;

        if (data.elem_product_menu) {
          this.productMenu = data.elem_product_menu;
        }

        if (data.elem_side_menu) {
          this.links = data.elem_side_menu.replace(
            'href="#" id="sidebar-sign-in"',
            'href="/account" id="sidebar-sign-in"'
          );
        }
      }

      SideMenuHandler.init();
    }
  }
</script>

<style>
  #side-menu {
    padding: 20px 30px;
    background: #21384d;
    transition: transform .3s;
    font-family: akrobat, sans-serif;
  }

    #side-menu div:nth-child(1) {
      display: none;
    }

    #side-menu #sitemap {
      color: #fff;
      background-color: #21384d;
      font-size: 14px;
    }

  #sitemap ul li {
    padding: 2px 0;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
  }

  #sitemap .title {
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
  }

  #side-menu #sitemap ul li a {
    margin-left: 0;
    position: relative;
    display: block;
    color: #ccc !important;
    font-size: 14px;
    line-height: 24px;
  }

  #side-menu #sitemap ul li a:hover {
    text-decoration: none;
    color: #fff !important;
  }

    #side-menu #sitemap ul li a:before {
      font-style: normal !important;
      font-weight: 400 !important;
      font-variant: normal !important;
      text-transform: none !important;
      speak: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      content: " ";
      position: absolute;
      left: -20px;
    }

  #product-menu > a.close {
    display: none;
  }

  .nav {
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-weight: 300;
    font-family: akrobat, sans-serif;
  }

  .navbar-nav {
    margin-top: 0;
    margin-bottom: 0;
  }

  .main-nav > li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .navbar-nav > li {
    float: left;
  }

  .nav > li {
    position: relative;
    display: block;
  }

  .navbar-nav > li > a {
    color: #333 !important;
    text-decoration: none !important;
    font-weight: 700;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 1.2rem;
  }

    .navbar-nav > li > a:hover {
      color: #000 !important;
    }

  #product-menu .container {
    width: 1170px;
    padding: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  img.menu-featured-product-image {
    width: 80%;
    max-width: 190px;
    display: block;
  }

  #product-menu, #site-menu {
    background-color: rgba(242, 242, 242, 0.9);
    color: #4f4f4f;
    font-size:0.9rem;
    padding-top: 30px;

     transition: .3s 0s ease-in-out transform, 0s .4s opacity;
    /*  z-index: 22;
     transform: translateY(-100%);
     position: absolute;
     top: 58px;
     left: 0;
     right: 0;
     max-height: 100%;
     max-height: calc(100vh - 58px);
     overflow: auto;
     padding-bottom: 40px;
     -webkit-transition: .3s 0s ease-in-out -webkit-transform, 0s .4s opacity;
     -o-transition: .3s 0s ease-in-out -o-transform, 0s .4s opacity;
     -webkit-transform: translateY(-100%);
     -ms-transform: translateY(-100%);
     -o-transform: translateY(-100%);
     opacity: 0; */
  }

  #product-menu h2 {
    margin: 20px 0 10px;
    color: #000 !important;
    font-weight: 600;
    font-size: 1.7em;
  }

  #product-menu a {
    color: #333 !important;
    text-decoration: none !important;
  }

    #product-menu a.raa {
      color: #008ad9 !important;
    }

  #product-menu ul {
    list-style: none;
    padding: 0;
  }

    #product-menu ul li {
      margin-bottom: 0.5rem;
    }

      #product-menu ul li a {
        color: #000 !important;
        font-size: 0.9rem;
        border: none;
      }

        #product-menu ul li a:hover {
          color: grey !important;
        }


  #product-menu .col-lg-4 {
    width: 33.33333333%;
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
    float: left;
  }

  #product-menu div[class*=col] {
    margin-bottom: 30px;
  }

  #product-menu .row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .menuitem_sb > a {
    position: relative;
    display: block;
  }

  .menuitem_sb .txt_newbuyingguide {
    position: absolute;
    bottom: 0;
    display: inline-block;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: #fff;
    border-radius: 10px;
    text-transform: uppercase;
    background-color: #781486;
    background-image: -webkit-linear-gradient(left,#7533b3,#781486);
    background-image: -moz-linear-gradient(left,#7533b3,#781486);
    background-image: -o-linear-gradient(left,#7533b3,#781486);
    background-image: linear-gradient(to right,#7533b3,#781486);
  }

img.menu-featured-product-image {
    width: unset;
    max-width: 40%;
}

</style>

<style lang="scss" scoped>
  .main-header {
    margin: auto;
    max-width: 100%;
    position: static;
    top: 0;
    right: 0;
    left: 0;
    z-index: 3;
    box-shadow: 0 0 1px rgba(0,0,0,.3);
    background-color: #fff !important;
  }


  div.md-toolbar-row {
    max-width: 100%;
    h1

  {
    display: inline-block;
  }

  }

  .logo {
    width: 140px;
    border-radius: 0;
    .logo-creative

  {
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  }

  .logo.md-icon-button:before {
    border-radius: 0;
  }

  .vertical-line {
    display: inline-block;
    width: 1px;
    height: 64px;
    background-color: #ccc;
  }

  .login-btn {
    color: #666 !important;
  }

  .cross-btn {
  position:absolute;
  top: 10px;
  right:20px;
  z-index: 20
  }
</style>